import {useMemo} from 'react';

export default function useSummerDiscountPriceBeforeDiscount(price) {
  const DISCOUNT_PERCENTAGE = 0.15;
  const priceBeforeDiscount = useMemo(() => {
    return price / (1 - DISCOUNT_PERCENTAGE);
  }, [price]);

  const localizedPriceBeforeDiscount = useMemo(() => {
    return new Intl.NumberFormat('en-US', {
      currency: 'USD',
      style: 'currency'
    }).format(priceBeforeDiscount);
  }, [priceBeforeDiscount]);

  return {
    localizedPriceBeforeDiscount,
    priceBeforeDiscount
  };
}
